export { default as LicenseContainerComponent} from './components/LicenseContainer';
export { licenseAllowanceReducer } from './reducers';
export { serverReducer } from './reducers';
export { serviceOptionsReducer } from './reducers';



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/index.ts